import { render, staticRenderFns } from "./CommercialsHome.vue?vue&type=template&id=1be7bb3d&"
import script from "./CommercialsHome.vue?vue&type=script&lang=js&"
export * from "./CommercialsHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports